import { render, staticRenderFns } from "./_MessagesWrapper.vue?vue&type=template&id=fd344ca8&scoped=true&"
import script from "./_MessagesWrapper.vue?vue&type=script&lang=js&"
export * from "./_MessagesWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd344ca8",
  null
  
)

export default component.exports